import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import { collection, updateDoc, doc } from "firebase/firestore";

function EditNews(props) {
  const activeNews = props.activeNews;
  const newsRef = collection(db, "news");
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [lead, setLead] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => {
    setId(activeNews.id);
    setTitle(activeNews.title);
    setDate(activeNews.date);
    setLead(activeNews.lead);
    setBody(activeNews.body);
  }, []);

  const updateNews = async (id) => {
    const newsDoc = doc(db, "news", id);
    const newsInputs = {
      title: title,
      date: date,
      lead: lead,
      newsBody: body,
    };
    await updateDoc(newsDoc, newsInputs);
    alert("News Updated");
    props.refreshNews();
    props.closeForm();
  };

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="fixed inset-0 bg-slate-800/40"
        onClick={props.closeForm}
      ></div>
      <div className="fixed top-0 right-0 h-full w-full md:w-[420px] bg-white shadow-2xl flex flex-col transition-transform duration-300 ease-in-out translate-x-0">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-lg font-bold text-slate-800">Edit News</h2>
          <button
            className="text-slate-400 hover:text-slate-700 text-2xl leading-none cursor-pointer"
            onClick={props.closeForm}
          >
            &times;
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4 flex flex-col gap-5">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-slate-700">News Title <span className="text-rose-500">*</span></label>
            <input
              className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-slate-700">Date <span className="text-rose-500">*</span></label>
            <input
              className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-slate-700">News Lead</label>
            <input
              className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
              type="text"
              value={lead}
              onChange={(e) => setLead(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-1 flex-1">
            <label className="text-sm font-medium text-slate-700">Body</label>
            <textarea
              className="resize-none flex-1 min-h-48 border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
              value={body}
              onChange={(e) => setBody(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div className="px-6 py-4 border-t flex justify-end gap-3">
          <button
            className="px-4 h-10 rounded-lg border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
            onClick={props.closeForm}
          >
            Cancel
          </button>
          <button
            className="px-4 h-10 rounded-lg bg-sky-600 text-white text-sm font-semibold hover:bg-sky-700 cursor-pointer"
            onClick={() => updateNews(activeNews.id)}
          >
            Update News
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditNews;
